import React from "react";
import Card from "components/card";
import { CalendarDays } from "lucide-react";
import { getIcon } from "variables/constants";

const HolidayCard = ({ 
    hol_name,
    country,
    hol_date,
    code
}) => {

    return (
        <Card className="flex items-center justify-between p-4 rounded-2xl border-2 bg-white hover:border-emerald-200 hover:shadow-md transition-all duration-200 dark:bg-black/5" >
            <div className="flex items-center gap-4">
                <div className="w-10 h-10 rounded-xl bg-emerald-100 flex items-center justify-center">
                    <CalendarDays className="w-5 h-5 text-emerald-600" />
                </div>
                <div>
                    <p className="text-[13px] font-semibold dark:text-white">
                        {hol_name}
                    </p>
                    <div className="flex items-center gap-2 mt-1">
                        <span>
                            {getIcon(code)}
                        </span>
                        <span className="text-[11px] text-slate-700 dark:text-slate-100">{country}</span>
                    </div>
                </div>
            </div>
            <span className="inline-flex items-center justify-center rounded-lg border px-2 py-0.5 text-xs font-medium shrink-0 gap-1 bg-emerald-50 text-emerald-700 border-emerald-200 dark:bg-emerald-800/10 dark:text-green-100">
                {hol_date}
            </span>
        </Card>
    );
};

export default HolidayCard;